import { AutocompleteLead } from '../models/lead-campaign'



export const list_user: AutocompleteLead[] = [
  {
    label: 'Ribeira (Martins)',
    matched_record: {
      id: 'PESS1111',
      name: 'Ribeiro da Silva',
      nickname: 'Ribeiro',
      picture_url: 'https://i.pinimg.com/564x/e0/ac/70/e0ac70d280116dfe323d27b65f2617c9.jpg',
      leaders: [
        {
          id: 'PESS3333',
          name: 'Martins da Silva',
          nickname: 'Martins'
        }
      ]
    }
  },
  {
    label: 'Fernanda (Martins)',
    matched_record: {
      id: 'PESS1111',
      name: 'Ribeiro da Silva',
      nickname: 'Ribeiro',
      picture_url: 'https://a.wattpad.com/cover/80966922-352-k683006.jpg',
      leaders: [
        {
          id: 'PESS3333',
          name: 'Martins da Silva',
          nickname: 'Martins'
        }
      ]
    }
  },
  {
    label: 'Alícia (Martins)',
    matched_record: {
      id: 'PESS1111',
      name: 'Ribeiro da Silva',
      nickname: 'Ribeiro',
      picture_url: 'https://i.pinimg.com/originals/03/68/ee/0368ee079e38e1fadc75445cfb04ef67.jpg',
      leaders: [
        {
          id: 'PESS3333',
          name: 'Martins da Silva',
          nickname: 'Martins'
        }
      ]
    }
  },
  {
    label: 'Raquel (Martins)',
    matched_record: {
      id: 'PESS1111',
      name: 'Ribeiro da Silva',
      nickname: 'Ribeiro',
      picture_url: 'https://static1.purepeople.com.br/articles/9/21/73/19/@/2492864--tao-doce-tao-maravilhosa-a-mulher-mai-950x0-1.jpg',
      leaders: [
        {
          id: 'PESS3333',
          name: 'Martins da Silva',
          nickname: 'Martins'
        }
      ]
    }
  },
  {
    label: 'Priscila (Martins)',
    matched_record: {
      id: 'PESS1111',
      name: 'Ribeiro da Silva',
      nickname: 'Ribeiro',
      picture_url: 'https://1.bp.blogspot.com/-Qycf2qX_4uU/UvTtX2eFytI/AAAAAAAAAhI/dJ842ME0on4/s1600/megan-fox-face.jpg',
      leaders: [
        {
          id: 'PESS3333',
          name: 'Martins da Silva',
          nickname: 'Martins'
        }
      ]
    }
  },

  {
    label: 'Agata (Martins)',
    matched_record: {
      id: 'PESS1111',
      name: 'Ribeiro da Silva',
      nickname: 'Ribeiro',
      picture_url: 'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQQgpjxa72vPDXmoqGkXZUv8Z-0tKLgqsm4Zw&usqp=CAU',
      leaders: [
        {
          id: 'PESS3333',
          name: 'Martins da Silva',
          nickname: 'Martins'
        }
      ]
    }
  }
]